import { HotelListItem } from "@/api/hotel";
import { stripHtml } from "@/utils/format";

interface HotelCardProps {
  hotel: HotelListItem;
  onClick: (id: number) => void;
}

export default function HotelCard({ hotel, onClick }: HotelCardProps) {
  return (
    <div
      onClick={() => onClick(hotel.id)}
      className="bg-white rounded-2xl overflow-hidden cursor-pointer transition-all active:scale-[0.98]"
      style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.06)", height: 126 }}
    >
      <div className="flex h-full gap-0">
        {/* Image：固定撑满整卡高度，不随文字多少变化 */}
        <div className="relative flex-shrink-0" style={{ width: 100 }}>
          <img
            src={hotel.cover_image || hotel.room_cover}
            alt={hotel.hotel_name}
            className="w-full h-full object-cover object-top"
          />
        </div>
        {/* Content */}
        <div className="flex-1 pl-2.5 pr-3 pt-2.5 pb-2 min-w-0 flex flex-col justify-between">
          <div className="min-w-0">
            <div className="text-sm font-semibold text-gray-800 leading-snug line-clamp-1">
              {hotel.hotel_name}
            </div>
            <div className="flex items-center gap-1 mt-0.5">
              {[1, 2, 3, 4, 5].map((s) => (
                <i
                  key={s}
                  className="ri-star-fill"
                  style={{
                    color:
                      s <= Math.floor(hotel.avg_product_score)
                        ? "#F59E0B"
                        : "#E5E7EB",
                    fontSize: 11,
                  }}
                />
              ))}
              <span className="text-xs font-semibold text-gray-700 ml-0.5">
                {hotel.avg_product_score}
              </span>
              <span className="text-xs text-gray-400 ml-0.5">
                ({hotel.comment_count}条)
              </span>
            </div>
          </div>

          <div>
            {/* 星级标签 */}
            {hotel.star_rating_text && (
              <span
                className="inline-block text-xs px-1.5 py-0.5 rounded-md mt-1"
                style={{ background: "#F0F9FF", color: "#0369A1" }}
              >
                {hotel.star_rating_text}
              </span>
            )}
            <div className="flex items-center gap-1 mt-0.5">
              <i
                className="ri-map-pin-line"
                style={{ color: "#9CA3AF", fontSize: 11 }}
              />
              <span className="text-xs text-gray-400 truncate pr-8">
                {(() => {
                  const district = stripHtml(hotel.district).trim();
                  const address = stripHtml(hotel.address).trim();
                  const dist = (hotel.distance_text || "").trim();
                  if (district && dist) return `${district} · ${dist}`;
                  if (dist) return dist;
                  if (district) return district;
                  return address || "暂无位置信息";
                })()}
              </span>
            </div>
          </div>

          <div className="flex items-end justify-end mt-1">
            <span
              className="font-bold mr-0.5"
              style={{ color: "#EF4444", fontSize: 18 }}
            >
              ¥{hotel.min_price}
            </span>
            <span className="text-xs text-gray-400 pb-0.5">起</span>
            <span className="text-[10px] text-gray-300 ml-1.5">每晚</span>
          </div>
        </div>
      </div>
    </div>
  );
}
